<template>
  <svg :style="computedDimensions">
    <use xlink:href="#icon-spinner-white" v-if="white"></use>
    <use xlink:href="#icon-spinner" v-else></use>
  </svg>
</template>

<script>
export default {
  props: {
    white: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    }
  },

  computed: {
    computedDimensions () {
      if (!this.width && !this.height) {
        return {
          width: '10rem',
          height: '10rem'
        }
      }

      return {
        width: this.height && !this.width ? `${this.height}rem` : `${this.width}rem`,
        height: this.width && !this.height ? `${this.width}rem` : `${this.height}rem`
      }
    }
  }
}
</script>
